import { FormControlLabel, formGroupClasses, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircuitCreateStepperData } from "./circuitCreateStepper";

interface CircuitCreateStepperPackagePriceTypeProps {
    data: CircuitCreateStepperData;
    setData: React.Dispatch<React.SetStateAction<CircuitCreateStepperData>>;
    stepIndex: number;
}

export const CircuitCreateStepperPackagePriceType: FC<CircuitCreateStepperPackagePriceTypeProps> = ({ data, setData, stepIndex }) => {
    const { t } = useTranslation();

    const getPriceTypeValue = () => {
        if (data.forfait_price && !data.price_mix) return 'sum_products';
        if (!data.forfait_price && !data.price_mix) return 'manual';
        if (!data.forfait_price && data.price_mix) return 'mix';
        return 'manual';
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        switch (value) {
            case 'sum_products':
                setData((state) => ({ ...state, forfait_price: true, price_mix: false }));
                break;
            case 'manual':
                setData((state) => ({ ...state, forfait_price: false, price_mix: false }));
                break;
            case 'mix':
                setData((state) => ({ ...state, forfait_price: false, price_mix: true }));
                break;
        }
    };

    return (
        <Stack direction={'column'} justifyContent={'center'} sx={{ maxWidth: 'md', width: '100%', gap: 7 }}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="h3" sx={{ color: '#486284', fontWeight: 700 }}>{t('shared.step-number', { count: stepIndex + 1 })} : {t('shared.price-type')}</Typography>
                <Typography variant="subtitle1" sx={{ color: '#8CA2C0', fontWeight: 400 }}>{t('shared.package-forfait-price-helper-text')}</Typography>
            </Stack>
            <Stack direction={'row'} alignItems={'center'} sx={{ width: '100%' }} spacing={2}>
                <RadioGroup
                    value={getPriceTypeValue()}
                    name="price_type"
                    onChange={onChange}
                    sx={{
                        [`&.${formGroupClasses.root}`]: {
                            gap: 2
                        }
                    }}
                >
                    <FormControlLabel
                        value={'sum_products'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.pricing-table")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem', variant: 'body1' } } }}
                    />
                    <FormControlLabel
                        value={'manual'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.tour-prices")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                    <FormControlLabel
                        value={'mix'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.circuit-mix-price")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                </RadioGroup>

            </Stack>
        </Stack>
    );
};